<template>
  <div>
    <ControlPanel :title="'Раздел: Заработная плата'" :icon="'mdi mdi-folder'" :links="links">
    </ControlPanel>
    <div class="container-fluid">
      <Category>
        <template v-slot:pos1>
          <p>В данном разделе вы можете посчитать заработную плату или произвести расчет дополнительных начислений (отпускные, больничные листы, компенсация отпуска при увольнении).</p>
        </template>

        <template v-slot:pos2>
          <table class="table table-sm table-bordered">
            <tr>
              <td><b-link to="/">Калькулятор заработной платы</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/salary/sums/">Сохраненные начисления заработной платы</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/salary/additionalcharges/">Калькулятор отпускных, больничных листов, компенсации отпуска при увольнении</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/salary/additionalcalcs/">Сохраненные расчеты отпускных, больничных листов, компенсации отпуска при увольнении</b-link></td>
            </tr>
          </table>
        </template>
      </Category>
    </div>
  </div>
</template>

<script>
import ControlPanel from "@/components/base/ControlPanel";
import Category from "@/components/base/Category";
import {mapGetters} from "vuex";

export default {
  name: 'SalaryDefault.vue',
  components: {
    ControlPanel,
    Category
  },
  data: function () {
    return {

    }
  },
  computed:  {
    ...mapGetters({
      links: 'links'
    })
  },
}
</script>

<style scoped>

</style>
